import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-youtube-embed',
  templateUrl: './youtube-embed.component.html',
  styleUrls: ['./youtube-embed.component.scss']
})
export class YoutubeEmbedComponent implements OnChanges{
  @Input() youtubeUrl?: string | undefined;
  @Input() height?: number | undefined;
  @Input() width?: number | undefined;
  safeSrc: SafeResourceUrl ;

  constructor(private sanitizer: DomSanitizer) {
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.youtubeUrl || '');
   
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['youtubeUrl']) {
      this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.youtubeUrl || '');
    }
  }
}
